import React from 'react';
import { connect } from 'react-redux';
import { GenreDetailContainerStyled } from './styled';
import { adminService } from 'apiService';
// import { iconImages } from 'assets';
import { setReduxUserAuth } from 'actions';
import { ReactTableExpand, ReactTable, ButtonCustom } from 'components';
import { ROUTE_PATH } from 'helpers';
import { Helmet } from "react-helmet";

class GenreDetailContainer extends React.Component {
  state = { dataGenre: [] };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let res = await adminService.GET_GENRES_LIST();
    // console.log("ressssssssssssss ", res.data)
    if (res && res.success) {
      this.setState({
        dataGenre: res.data,
      });
    }
  };

  handdleClickAddGenre = () => {
    this.props.history.push(ROUTE_PATH.A_GENRE + '/create');
  };

  handdleClickEditGenre = (e) => {
    this.props.history.push(ROUTE_PATH.A_GENRE + '/' + e);
  };

  handdleClickCreatorDetail = (e) => {
    this.props.history.push(ROUTE_PATH.A_CREATOR + '/' + e);
  };

  handleClickGenre = async (e) => {
    let resGen = await adminService.GET_GENRES_DETAIL(e);
    // console.log("ressssssssssssss  geee", resGen.data)
    if (resGen && resGen.success) {
      this.setState({
        dataListGenre: resGen.data,
      });
    }
  };

  render() {
    const { dataGenre, dataListGenre } = this.state;
    return (
      <GenreDetailContainerStyled>
        <Helmet>
          <title>admin</title>
        </Helmet>
        <div className="main_layout">
          <div className="tab_layout">
            <div className="title_layout">
              Genre System
            </div>
            <div className="button_layer" >
              <ButtonCustom
                theme_standard
                label="New Genre"
                onClick={this.handdleClickAddGenre}
              />
            </div>
          </div>
          <ReactTableExpand
            columns={columns({ handleClickGenre: this.handleClickGenre, handdleClickEditGenre: this.handdleClickEditGenre })}
            data={dataGenre}
            renderRowSubComponent={({ row }) => renderRowSubComponent({ row, handdleClickCreatorDetail: this.handdleClickCreatorDetail, dataListGenre })}
          />
        </div>
      </GenreDetailContainerStyled>
    );
  }
}

const columns = ({ handleClickGenre, handdleClickEditGenre }) => [
  {
    // Make an expander cell
    Header: () => null, // No header
    id: 'expander', // It needs an ID
    Cell: ({ row, rows, toggleRowExpanded }) => (
      // Use Cell to render an expander for each row.
      // We can use the getToggleRowExpandedProps prop-getter
      // to build the expander.
      <div onClick={() => handleClickGenre(row.original.slug)}>
        <span
          {...row.getToggleRowExpandedProps({
            onClick: () => {
              const expandedRow = rows.find(row => row.isExpanded);

              if (expandedRow) {
                const isSubItemOfRow = Boolean(
                  expandedRow && row.id.split(".")[0] === expandedRow.id
                );

                if (isSubItemOfRow) {
                  const expandedSubItem = expandedRow.subRows.find(
                    subRow => subRow.isExpanded
                  );

                  if (expandedSubItem) {
                    const isClickedOnExpandedSubItem =
                      expandedSubItem.id === row.id;
                    if (!isClickedOnExpandedSubItem) {
                      toggleRowExpanded(expandedSubItem.id, false);
                    }
                  }
                } else {
                  toggleRowExpanded(expandedRow.id, false);
                }
              }
              row.toggleRowExpanded();
            }
          })}
        >
          {row.isExpanded ? '👇' : '👉'}
        </span>
      </div>
    ),
  },
  {
    Header: 'Order No',
    accessor: 'order',
    style: { width: '100px' },
  },
  {
    Header: 'Genre Name',
    accessor: 'label',
  },
  {
    Header: 'No. of Creators',
    accessor: 'creators_count',
    style: { width: '150px' },
  },
  {
    Header: 'Picture',
    accessor: 'poster_photo_uri',
    style: { width: '200px' },
    Cell: (e) => (
      <div style={{ width: '100%', height: '100px', backgroundImage: `url("${e.value}")`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} />
    ),
  },
  {
    Header: 'Detail',
    accessor: 'slug',
    Cell: (e) => (
      <div style={{ textAlign: 'center' }}>
        <button onClick={() => handdleClickEditGenre(e.value)}>detail</button>
      </div>
    ),
  },
];

const columns2 = ({ handdleClickCreatorDetail }) => [
  {
    Header: 'Creator Id',
    accessor: 'id',
  },
  {
    Header: 'Display Name',
    accessor: 'displayname',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Header: 'Detail',
    Cell: ({ row: { index, original } }) => (
      <div style={{ textAlign: 'center' }}>
        <button onClick={() => handdleClickCreatorDetail(original.id)}>detail</button>
      </div>
    ),
  },
];

const renderRowSubComponent = ({ row, handdleClickCreatorDetail, dataListGenre }) => (
  <pre
    style={{
      fontSize: '10px',
    }}
  >
    <ReactTable
      notUsePagi
      columns={columns2({ handdleClickCreatorDetail: handdleClickCreatorDetail })}
      // columns={columns2({})}
      data={dataListGenre}
    />
  </pre>
);

const mapStateToProps = (state) => ({
  authRedux: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxUserAuth: (data) => dispatch(setReduxUserAuth(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GenreDetailContainer);
